<template>
    <e-tooltip :label="label" multilined :position="item.position" size="is-large">
        <e-icon icon="unlock" class="align-icon" />
    </e-tooltip>
</template>

<script>
export default {
    name: 'UnlockedItem',

    props: {
        item: {
            default: null,
            type: Object,
            required: true,
        },
    },

    computed: {
        label() {
            if (this.item.type === 'prerequisite') {
                return this.prerequisite;
            }

            if (this.item.type === 'visibleAt') {
                return this.item.visibleAt;
            }

            return `This ${this.type.toLowerCase()} is unlocked`;
        },

        type() {
            if (this.item.namespace !== 'Week Break') {
                this.item.namespace.toLowerCase();

                return this.item.namespace.includes('act') ? 'Activity' : 'Section';
            }

            return this.item.namespace;
        },

        prerequisite() {
            return `This ${this.type} is normally locked until ${this.item.prereqTitle} is completed.`;
        },
    },
};
</script>
<style scoped>
.align-icon {
    position: relative;
    top: -1px;
}
</style>
